/**
 * SubscriptionTiers Component
 * Renders list of TierCard components with upgrade functionality
 * 
 * Requirements: 7.1, 7.2
 */

import React from 'react';
import './SubscriptionTiers.css';
import TierCard from './TierCard';
import type { SubscriptionTier } from '../types';

interface SubscriptionTiersProps {
  tiers: SubscriptionTier[];
  currentTier: string;
  onUpgrade: (tier: SubscriptionTier) => void;
  isUpgrading: boolean;
}

const SubscriptionTiers: React.FC<SubscriptionTiersProps> = ({
  tiers,
  currentTier,
  onUpgrade,
  isUpgrading,
}) => {
  if (!tiers || !Array.isArray(tiers) || tiers.length === 0) {
    return null;
  }

  return (
    <div className="subscription-tiers">
      <div className="tiers-grid">
        {tiers.map((tier) => {
          if (!tier || !tier.name) return null;
          
          const tierName = String(tier.name || '').toLowerCase();
          const current = String(currentTier || '').toLowerCase();
          
          return (
            <TierCard
              key={tier.name}
              tier={tier}
              isCurrentTier={tierName === current}
              onUpgrade={onUpgrade}
              isUpgrading={isUpgrading}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SubscriptionTiers;
